import { render, staticRenderFns } from "./NotificationSnackbar.vue?vue&type=template&id=3683f7a4&scoped=true&"
import script from "./NotificationSnackbar.vue?vue&type=script&lang=js&"
export * from "./NotificationSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSnackbar.vue?vue&type=style&index=0&id=3683f7a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3683f7a4",
  null
  
)

export default component.exports